<template>
  <div>
    <v-container
      fluid
      :class="{
        'mx-12': !mobile,
        'my-6': !mobile
      }"
    >
      <div
        :class="{
          'd-flex': true,
          'flex-row': !mobile,
          'flex-column': mobile,
          'mb-4': !mobile
        }"
      >
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-cash-marker</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Down Payments</p>
        </div>
        <div v-if="!mobile" class="flex-grow-1"></div>
      </div>
      <v-row class="mb-0">
        <v-col class="py-0" cols="12" sm="12" md="4">
          <v-text-field
            v-model="searchString"
            solo
            flat
            append-icon="mdi-magnify"
            label="Search Tenant/Unit"
            hide-details
            class="mb-6"
            :dense="mobile"
            @click:append="searchAction"
            @keydown.enter="searchAction"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="4"
          sm="4"
          md="3"
          :class="{
            'py-0': true,
            'd-flex': mobile,
            'align-center': mobile,
            'justify-center': mobile
          }"
        >
          <v-select
            v-model="selectedStatuses"
            solo
            flat
            hide-details
            label="Select Status"
            :items="statusItems"
            :dense="mobile"
            multiple
            @change="searchAction"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="selectAllStatusesAndReload">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedStatuses.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ iconStatuses }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ selectedStatuses.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
      </v-row>
      <down-payment-table
        :search-string="searchString"
        :selected-statuses="selectedStatuses"
        :status-items="statusItems"
        :search-trigger="searchTrigger"
      ></down-payment-table>
    </v-container>
  </div>
</template>

<script>
import DownPaymentTable from '../../components/tables/DownPaymentTable.vue'

export default {
  components: {
    DownPaymentTable
  },
  data() {
    return {
      searchString: '',
      selectedStatuses: [],
      statusItems: [],
      searchTrigger: true
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    iconStatuses() {
      if (this.allStatusesSelected) return 'mdi-close-box'
      if (this.someStatusesSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    allStatusesSelected() {
      return (
        this.selectedStatuses.length ===
        (this.statusItems && this.statusItems.length)
      )
    },
    someStatusesSelected() {
      return this.selectedStatuses.length > 0 && !this.allStatusesSelected
    }
  },

  methods: {
    selectAllStatusesAndReload() {},
    async searchAction() {
      // change the value to trigger the watch in child
      this.searchTrigger = !this.searchTrigger
    }
  }
}
</script>
